import jwt from '@src/auth/jwt/useJwt'

export const suspendUserApi = async ({ adminId, userId, reason }) => {
  const body = new URLSearchParams()
  if (reason) body.append('reason', reason)

  try {
    const response = await jwt.post(`admin/user/${userId}/suspend`, body, {
      headers: {
        UserId: adminId,
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
    return response.data
  } catch (error) {
    const status = error?.response?.status

    if (status === 403) {
      const err = new Error('Forbidden')
      err.type = 'FORBIDDEN'
      throw err
    }

    if (status === 404) {
      const err = new Error('Usuario no encontrado.')
      err.type = 'NOT_FOUND'
      throw err
    }

    const err = new Error(error?.response?.data?.message || `Error del servidor: ${status || 'unknown'}`)
    err.type = 'SERVER_ERROR'
    throw err
  }
}

export const fetchClientsApi = async ({ offset, userId, clientUserId }) => {
  const params = {}

  if (clientUserId) {
    params.user_id = clientUserId
  } else {
    params.offset = String(offset)
  }

  try {
    const response = await jwt.get('admin/clients', {
      params,
      headers: { UserId: userId }
    })
    return response.data
  } catch (error) {
    const status = error?.response?.status

    if (status === 403) {
      const err = new Error('Forbidden')
      err.type = 'FORBIDDEN'
      throw err
    }

    if (status === 400) {
      const message = error?.response?.data?.message || 'Parámetros inválidos'
      const err = new Error(message)
      err.type = 'BAD_REQUEST'
      throw err
    }

    const err = new Error(`Error del servidor: ${status || 'unknown'}`)
    err.type = 'SERVER_ERROR'
    throw err
  }
}
